import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "drag-text-content" }
const _hoisted_2 = { class: "drag-text-content" }

import { useSystemConfigStore } from '@/store/SystemConfigStore';
import { useAiOrderStore } from '@/store/AiOrderTaskStore';
import { useUserStore } from '@/store/UserStore';
import SignalRService from '@/typescript/Services/SignalRService';
import { _DragComponent } from '@varlet/ui';
import { inject, onMounted, ref, watch } from 'vue';
import { useTaskStatisticeStore } from '@/store/TaskStatisticeStore';

export default /*@__PURE__*/_defineComponent({
  __name: 'AIPopupComponent',
  setup(__props) {

const dragRef = ref<_DragComponent>();
const aiOrderStore = useAiOrderStore();
const taskStatisticeStore = useTaskStatisticeStore(); //统计用
const userData = useUserStore();
const IsMobile = inject<boolean>("IsMobile");
const systemConfigStore = useSystemConfigStore();

/**
 * 打开任务详情
 */
function Open() {
    aiOrderStore.show = true;
}



onMounted(() => {
    // const drag = document.querySelector('#drag') as HTMLDivElement;
    // const top = 100;
    // const left = globalThis.innerWidth - drag.clientWidth;
    // drag.style = `left: ${left}px; top: ${top}px;`;
});



return (_ctx: any,_cache: any) => {
  const _component_VarImage = _resolveComponent("VarImage")!
  const _component_VarSpace = _resolveComponent("VarSpace")!
  const _component_var_progress = _resolveComponent("var-progress")!
  const _component_VarDrag = _resolveComponent("VarDrag")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_unref(IsMobile))
    ? (_openBlock(), _createBlock(_component_VarDrag, {
        key: 0,
        class: "ai-popup-body",
        id: "drag",
        ref_key: "dragRef",
        ref: dragRef,
        style: {"right":"30px","top":"230px"},
        onClick: Open
      }, {
        default: _withCtx(() => [
          _createVNode(_component_var_progress, {
            class: "progress-box",
            mode: "circle",
            type: "success",
            label: "",
            value: 100,
            "line-width": 7.5,
            size: 75,
            color: {
                    '0%': '#3fecff',
                    '100%': '#6149f6',
                }
          }, {
            default: _withCtx(() => [
              (_unref(taskStatisticeStore).HasAi)
                ? _withDirectives((_openBlock(), _createBlock(_component_VarImage, {
                    key: 0,
                    radius: "50%",
                    width: "65px",
                    height: "65px",
                    fit: "cover",
                    src: require('@/assets/images/ai_work.gif')
                  }, null, 8, ["src"])), [
                    [_directive_ripple]
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_VarImage, {
                    key: 1,
                    radius: "50%",
                    width: "65px",
                    height: "65px",
                    fit: "cover",
                    src: require('@/assets/images/ai_sleep.gif')
                  }, null, 8, ["src"])), [
                    [_directive_ripple]
                  ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_VarSpace, { direction: "column" }, {
                  default: _withCtx(() => [
                    (_unref(taskStatisticeStore).HasAi)
                      ? (_openBlock(), _createBlock(_component_VarSpace, {
                          key: 0,
                          justify: "center",
                          align: "center",
                          direction: "column",
                          size: "5"
                        }, {
                          default: _withCtx(() => _cache[0] || (_cache[0] = [
                            _createElementVNode("span", { class: "ai-name" }, "AI", -1)
                          ])),
                          _: 1,
                          __: [0]
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                  ]),
                  _: 1
                })
              ])), [
                [_directive_ripple]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "pc-ai-popup-body",
        id: "drag",
        ref_key: "dragRef",
        ref: dragRef,
        onClick: Open
      }, [
        _createVNode(_component_var_progress, {
          class: "progress-box",
          mode: "circle",
          type: "success",
          label: "",
          value: 100,
          "line-width": 5.5,
          size: 50,
          color: {
                    '0%': '#3fecff',
                    '100%': '#6149f6',
                }
        }, {
          default: _withCtx(() => [
            (_unref(taskStatisticeStore).HasAi)
              ? _withDirectives((_openBlock(), _createBlock(_component_VarImage, {
                  key: 0,
                  radius: "50%",
                  width: "50px",
                  height: "50px",
                  fit: "cover",
                  src: require('@/assets/images/ai_work.gif')
                }, null, 8, ["src"])), [
                  [_directive_ripple]
                ])
              : _withDirectives((_openBlock(), _createBlock(_component_VarImage, {
                  key: 1,
                  radius: "50%",
                  width: "50px",
                  height: "50px",
                  fit: "cover",
                  src: require('@/assets/images/ai_sleep.gif')
                }, null, 8, ["src"])), [
                  [_directive_ripple]
                ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_VarSpace, { direction: "column" }, {
                default: _withCtx(() => [
                  (_unref(taskStatisticeStore).HasAi)
                    ? (_openBlock(), _createBlock(_component_VarSpace, {
                        key: 0,
                        justify: "center",
                        align: "center",
                        direction: "column",
                        size: "5"
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createElementVNode("span", { class: "ai-name" }, "AI", -1)
                        ])),
                        _: 1,
                        __: [1]
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                ]),
                _: 1
              })
            ])), [
              [_directive_ripple]
            ])
          ]),
          _: 1
        })
      ], 512))
}
}

})